import Paginate from "../../layout/Paginate";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ListingCard from "../Common/ListingCard";

const SoldItems = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Sold Items"} />
      <Paginate
        element={(props) => <ListingCard {...props} />}
        data={new Array(22).fill(0)}
        itemsPerPage={8}
        containerClassName="flex flex-col gap-10 py-10"
      />
    </div>
  );
};

export default SoldItems;
